'use client';
import React, { useEffect } from 'react';

const WhatsAppChatWidget = () => {
  useEffect(() => {
    // Load WhatsApp widget script
    const url = 'https://whatsapp-chat-widget.web.app/whatsapp-chat-widget.js';
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = url;

    const chatOptions = {
      "buttonSetting": {
        "ctaText": "Chat With Us",
        "positionIsBottomRight": true,
        "backgroundColor": "#37c968",
        "borderRadius": 40,
      },
      "widgetSetting": {
        "companyName": "Sai Shishir Tours",
        "companySubTitle": "Travel Planning Made Easy",
        "companyImg": "https://saishishirtours.in/wp-content/uploads/2018/12/Sai-Shishir-Tours-Logo-3.png",
        "phoneNumber": "918951062993",
        "welcomeText": "Hi there!\nHow can I help you?",
        "userSentText": "Hello, I have a question about {{page_title}}",
        "showByDefault": false,
        "ctaText": "Start chat",
        "headerBackgroundColor": "#2ac6b1",
        "borderRadius": 30,
      }
    };

    script.onload = function() {
      // @ts-ignore
      if (window.createWhatsappChatWidget) {
        // @ts-ignore
        window.createWhatsappChatWidget(chatOptions);
      }
    };

    document.body.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      document.body.removeChild(script);
    };
  }, []);

  return null; // This component doesn't render anything visible
};

export default WhatsAppChatWidget;